export const localeToLCIDMap: { [key: string]: number } = {
  'ar-SA': 1025,
  'bg-BG': 1026,
  'ca-ES': 1027,
  'zh-TW': 1028,
  'cs-CZ': 1029,
  'da-DK': 1030,
  'de-DE': 1031,
  'el-GR': 1032,
  'en-US': 1033,
  'es-ES': 1034,
  'fi-FI': 1035,
  'fr-FR': 1036,
  'he-IL': 1037,
  'hu-HU': 1038,
  'is-IS': 1039,
  'it-IT': 1040,
  'ja-JP': 1041,
  'ko-KR': 1042,
  'nl-NL': 1043,
  'nb-NO': 1044,
  'pl-PL': 1045,
  'pt-BR': 1046,
  'rm-CH': 1047,
  'ro-RO': 1048,
  'ru-RU': 1049,
  'hr-HR': 1050,
  'sk-SK': 1051,
  'sq-AL': 1052,
  'sv-SE': 1053,
  'th-TH': 1054,
  'tr-TR': 1055,
  'ur-PK': 1056,
  'id-ID': 1057,
  'uk-UA': 1058,
  'be-BY': 1059,
  'sl-SI': 1060,
  'et-EE': 1061,
  'lv-LV': 1062,
  'lt-LT': 1063,
  'tg-Cyrl-TJ': 1064,
  'fa-IR': 1065,
  'vi-VN': 1066,
  'hy-AM': 1067,
  'az-Latn-AZ': 1068,
  'eu-ES': 1069,
  'wen-DE': 1070,
  'mk-MK': 1071,
  'st-ZA': 1072,
  'ts-ZA': 1073,
  'tn-ZA': 1074,
  'ven-ZA': 1075,
  'xh-ZA': 1076,
  'zu-ZA': 1077,
  'af-ZA': 1078,
  'ka-GE': 1079,
  'fo-FO': 1080,
  'hi-IN': 1081,
  'mt-MT': 1082,
  'se-NO': 1083,
  'gd-GB': 1084,
  yi: 1085,
  'ms-MY': 1086,
  'kk-KZ': 1087,
  'ky-KG': 1088,
  'sw-KE': 1089,
  'tk-TM': 1090,
  'uz-Latn-UZ': 1091,
  'tt-RU': 1092,
  'bn-IN': 1093,
  'pa-IN': 1094,
  'gu-IN': 1095,
  'or-IN': 1096,
  'ta-IN': 1097,
  'te-IN': 1098,
  'kn-IN': 1099,
  'ml-IN': 1100,
  'as-IN': 1101,
  'mr-IN': 1102,
  'sa-IN': 1103,
  'mn-MN': 1104,
  'bo-CN': 1105,
  'cy-GB': 1106,
  'km-KH': 1107,
  'lo-LA': 1108,
  'my-MM': 1109,
  'gl-ES': 1110,
  'kok-IN': 1111,
  mni: 1112,
  'sd-IN': 1113,
  'syr-SY': 1114,
  'si-LK': 1115,
  'chr-US': 1116,
  'iu-Cans-CA': 1117,
  'am-ET': 1118,
  tmz: 1119,
  'ks-Arab-IN': 1120,
  'ne-NP': 1121,
  'fy-NL': 1122,
  'ps-AF': 1123,
  'fil-PH': 1124,
  'dv-MV': 1125,
  'bin-NG': 1126,
  'fuv-NG': 1127,
  'ha-Latn-NG': 1128,
  'ibb-NG': 1129,
  'yo-NG': 1130,
  'quz-BO': 1131,
  'nso-ZA': 1132,
  'ig-NG': 1136,
  'kr-NG': 1137,
  'gaz-ET': 1138,
  'ti-ER': 1139,
  'gn-PY': 1140,
  'haw-US': 1141,
  la: 1142,
  'so-SO': 1143,
  'ii-CN': 1144,
  'pap-AN': 1145,
  'ug-Arab-CN': 1152,
  'mi-NZ': 1153,
  'ar-IQ': 2049,
  'zh-CN': 2052,
  'de-CH': 2055,
  'en-GB': 2057,
  'es-MX': 2058,
  'fr-BE': 2060,
  'it-CH': 2064,
  'nl-BE': 2067,
  'nn-NO': 2068,
  'pt-PT': 2070,
  'ro-MD': 2072,
  'ru-MD': 2073,
  'sr-Latn-CS': 2074,
  'sv-FI': 2077,
  'ur-IN': 2080,
  'az-Cyrl-AZ': 2092,
  'ga-IE': 2108,
  'ms-BN': 2110,
  'uz-Cyrl-UZ': 2115,
  'bn-BD': 2117,
  'pa-PK': 2118,
  'mn-Mong-CN': 2128,
  'bo-BT': 2129,
  'sd-PK': 2137,
  'tzm-Latn-DZ': 2143,
  'ks-Deva-IN': 2144,
  'ne-IN': 2145,
  'quz-EC': 2155,
  'ti-ET': 2163,
  'ar-EG': 3073,
  'zh-HK': 3076,
  'de-AT': 3079,
  'en-AU': 3081,
  'fr-CA': 3084,
  'sr-Cyrl-CS': 3098,
  'ar-LY': 4097,
  'zh-SG': 4100,
  'de-LU': 4103,
  'en-CA': 4105,
  'fr-CH': 4108,
  'hr-BA': 4122,
  'ar-DZ': 5121,
  'zh-MO': 5124,
  'de-LI': 5127,
  'en-NZ': 5129,
  'fr-LU': 5132,
  'bs-Latn-BA': 5146,
  'ar-MO': 6145,
  'fr-MC': 6156,
  'ar-TN': 7169,
  'ar-OM': 8193,
  'ar-YE': 9217,
  'en-BZ': 10249,
  'es-PE': 10250,
  'fr-SN': 10252,
  'ar-JO': 11265,
  'fr-CM': 11276,
  'en-ID': 14345,
  'es-CL': 13322,
  'en-HK': 15369,
  'fr-MA': 14348,
  'en-MY': 17417,
  'es-SV': 17418,
  'es-NI': 19466,
  'es-PR': 20490,
  'es-US': 21514,
  'fr-015': 58380,
};

export function findBestLocaleFromString(value: string): { locale: string; localeId: number } {
  // Attempt to find an exact match in the map
  if (localeToLCIDMap[value]) {
    return {
      locale: value,
      localeId: localeToLCIDMap[value],
    };
  }

  // Fallback: Check for a partial match (e.g., "en" in "en-US")
  const partialMatch = Object.keys(localeToLCIDMap).find((key) => key.startsWith(value.split('-')[0]));

  if (partialMatch) {
    return {
      locale: partialMatch,
      localeId: localeToLCIDMap[partialMatch],
    };
  }

  // Default result if no match is found
  throw new Error(`Locale '${value}' is not supported.`);
}
